export const API_KEY = "6fqYpdf48hkZvsP4lnQ5o3n6H3jsR4OL"

export const API_URL = "https://api.giphy.com/v1"
